{
  "fr": {
    "pinboard": {
      "activity": {
        "board": {
          "addAttachment": "<strong>{user}</strong> a ajouté la pièce jointe <a href=\"{url}\" target=\"_blank\">{value}</a> à la carte <a href=\"{cardUrl}\">{cardName}</a>",
          "addAttachmentAfterRemoval": "<strong>{user}</strong> a ajouté la pièce jointe {value} à la carte <a href=\"{cardUrl}\">{cardName}</a>",
          "createCard": "<strong>{user}</strong> a créé la carte <a href=\"{cardUrl}\">{cardName}</a>",
          "destroyCard": "<strong>{user}</strong> a supprimé la carte <em>{cardName}</em>",
          "moveCard": "<strong>{user}</strong> a déplacé la carte <a href=\"{cardUrl}\">{cardName}</a> de <em>{oldValue}</em> à <em>{value}</em>",
          "removeAttachment": "<strong>{user}</strong> a supprimé la pièce jointe <em>{oldValue}</em> de la carte <a href=\"{cardUrl}\">{cardName}</a>",
          "updateCardColor": "<strong>{user}</strong> a changé la couleur de la carte",
          "updateCardCoverImage": "<strong>{user}</strong> a changé l'image de prévisualisation de la carte <a href=\"{cardUrl}\">{cardName}</a> en <a href=\"{url}\" target=\"_blank\">{value}</a>",
          "updateCardDescription": "<strong>{user}</strong> a modifié la description de la carte <a href=\"{cardUrl}\">{cardName}</a>",
          "updateCardName": "<strong>{user}</strong> a changé le nom de la carte <a href=\"{cardUrl}\">{cardName}</a> (de : <em>{oldValue}</em>)",
          "updateCardVisitorPermissions": "<strong>{user}</strong> a modifié l'autorisation des visiteurs de la carte <a href=\"{cardUrl}\">{cardName}</a> (de : <em>{oldValue}</em>)"
        },
        "card": {
          "addAttachment": "<strong>{user}</strong> a ajouté la pièce jointe <a href=\"{url}\" target=\"_blank\">{value}</a>",
          "addAttachmentAfterRemoval": "<strong>{user}</strong> a ajouté la pièce jointe {value}",
          "createCard": "<strong>{user}</strong> a créé cette carte",
          "moveCard": "<strong>{user}</strong> a déplacé cette carte de <em>{oldValue}</em> à <em>{value}</em>",
          "removeAttachment": "<strong>{user}</strong> a supprimé la pièce jointe <em>{oldValue}</em>",
          "updateCardColor": "<strong>{user}</strong> a changé la couleur de la carte",
          "updateCardCoverImage": "<strong>{user}</strong> a changé l'image de prévisualisation en <a href=\"{url}\" target=\"_blank\">{value}</a>",
          "updateCardDescription": "<strong>{user}</strong> a modifié la description de la carte",
          "updateCardName": "<strong>{user}</strong> a changé le nom de la carte (de : <em>{oldValue}</em>)",
          "updateCardVisitorPermissions": "<strong>{user}</strong> a modifié l'autorisation des visiteurs de la carte (de : <em>{oldValue}</em>)"
        },
        "missingUser": "Utilisateur supprimé"
      },
      "buttons": {
        "addAttachment": "Ajouter",
        "addCard": "Ajouter une carte",
        "addList": "Ajouter une liste",
        "color": "Couleur",
        "create": "Créer",
        "loadMore": "Charger plus",
        "openListSettings": "Ouvrir les paramètres de la liste"
      },
      "card": {
        "openFile": "Ouvrir le fichier",
        "openLink": "Ouvrir le lien",
        "setCoverAttachment": "Utiliser cette pièce jointe comme image de prévisualisation"
      },
      "colorPalette": {
        "colorDropdown": "Palette de couleurs"
      },
      "confirm": {
        "deleteAttachment": {
          "text": "Cette action est irréversible. La pièce jointe sera définitivement supprimée de la carte.",
          "title": "Supprimer la pièce jointe ?"
        },
        "deleteCard": {
          "text": "Cette action est irréversible. Tout le contenu de la carte sera définitivement supprimé.",
          "title": "Supprimer la carte ?"
        },
        "deleteComment": {
          "text": "Cette action est irréversible. Le commentaire sera définitivement supprimé de la carte.",
          "title": "Supprimer le commentaire ?"
        },
        "deleteList": {
          "text": "Cette action est irréversible. La liste sera définitivement supprimée avec toutes les cartes qu'elle contient.",
          "title": "Supprimer la liste ?"
        },
        "removeMember": {
          "text": "Le membre perdra l'accès à ce tableau d'affichage et à ses cartes.",
          "title": "Supprimer le membre ?"
        }
      },
      "errors": {
        "boardUpdateFailed": "Erreur lors de la mise à jour du tableau",
        "cardLimitReached": "Vous pouvez créer au maximum {limit} cartes dans cette liste.",
        "listLimitReached": "Vous pouvez créer au maximum {limit} listes sur ce tableau."
      },
      "flash": {
        "attachmentDeleted": "Pièce jointe supprimée",
        "boardUpdated": "Tableau mis à jour",
        "cardNotFound": "Carte introuvable",
        "colorUpdated": "Couleur mise à jour",
        "commentDeleted": "Commentaire supprimé",
        "commentUpdated": "Commentaire mis à jour",
        "coverImageUpdated": "Image de prévisualisation mise à jour",
        "descriptionUpdated": "Description mise à jour",
        "linkAdded": "Lien ajouté",
        "listRemoved": "Liste supprimée",
        "memberRemoved": "Membre supprimé",
        "permissionsUpdated": "Autorisations mises à jour",
        "titleUpdated": "Titre mis à jour"
      },
      "headers": {
        "activities": "Activités",
        "attachFile": "Joindre un fichier",
        "attachLink": "Joindre un lien",
        "members": "Membres",
        "permissions": "Autorisations",
        "pickColor": "Choisir une couleur",
        "visitorPermissions": "Les visiteurs peuvent..."
      },
      "labels": {
        "activity": "Activité",
        "attachments": "Pièces jointes",
        "cardTitle": "Titre de la carte",
        "inList": "dans {listName}",
        "visitorCanAddCards": "Supprimer et ajouter des cartes",
        "visitorCanAddList": "Supprimer et ajouter des listes",
        "visitorCanComment": "Commenter sur les cartes",
        "visitorCanViewActivities": "Voir l'historique des activités des cartes"
      },
      "links": {
        "activities": "Activités",
        "boardMembers": "Membres"
      },
      "paragraphs": {
        "addMembers": "Invitez des membres à votre tableau pour le gérer ensemble. Un compte fobizz est nécessaire.",
        "noMembers": "Vous n'avez pas encore invité d'autres membres à ce tableau.",
        "noMoreActivities": "Pas d'autres activités"
      },
      "placeholders": {
        "cardName": "Entrer un nom pour la carte...",
        "comment": "Entrer un commentaire ici...",
        "description": "Entrer une description ici...",
        "link": "Entrer une URL ici...",
        "listName": "Entrer un nom pour la liste...",
        "searchImages": "Entrer un terme de recherche ou une couleur..."
      },
      "toolName": "Tableau",
      "visitorPermissions": {
        "cardDescription": {
          "visitor_permissions_invisible": "Les visiteurs ne peuvent pas voir la carte.",
          "visitor_permissions_read": "Les visiteurs peuvent voir la carte.",
          "visitor_permissions_write": "Les visiteurs peuvent modifier la carte."
        },
        "listDescription": {
          "visitor_permissions_invisible": "Les visiteurs ne peuvent pas voir la liste.",
          "visitor_permissions_read": "Les visiteurs peuvent voir la liste.",
          "visitor_permissions_write": "Les visiteurs peuvent ajouter des cartes"
        },
        "permissions": "Autorisation des visiteurs"
      }
    }
  }
}
